import { BlockNoteEditor } from '@blocknote/core';
import { TextBlockSchema } from '../schema';

export default function isLinkMarkActiveAtSelection(
  editor: BlockNoteEditor<TextBlockSchema>,
) {
  const linkMark = editor.pmSchema.marks['link'];
  if (!linkMark) {
    return false;
  }
  const { doc, selection } = editor.prosemirrorState;
  const { $from, $to, empty } = selection;
  if (linkMark.isInSet($from.marks()) || linkMark.isInSet($to.marks())) {
    return true;
  }
  if (!empty) {
    return doc.rangeHasMark($from.pos, $to.pos, linkMark);
  }
  const pos = $from.pos;
  const docEnd = doc.content.size;
  if (
    pos < docEnd &&
    doc.rangeHasMark(pos, Math.min(pos + 1, docEnd), linkMark)
  ) {
    return true;
  }
  if (pos > 0 && doc.rangeHasMark(pos - 1, pos, linkMark)) {
    return true;
  }
  return false;
}
